import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../utils/styles';

export const StyledDestinationsList = styled.div`
  .destinations-list {
    .accordion__container {
      .accordion__heading {
        .accordion__image {
          .accordion_image_size {
            min-width: ${toRem(180)};
            min-height: ${toRem(60)};
            border-radius: ${toRem(8)};

            @media ${mediaQuery.allTablets} {
              max-height: ${toRem(60)};
              max-width: ${toRem(180)};
              min-height: ${toRem(60)};
              min-width: ${toRem(180)};
            }

            @media ${mediaQuery.mobileOnly} {
              max-height: ${toRem(50)};
              max-width: ${toRem(75)};
              min-height: ${toRem(50)};
              min-width: ${toRem(75)};
            }
          }
        }
      }
    }
  }
`;
